import { isValidUrl } from 'app/infrastructure/validation/url';
import { urlToSurveyManager } from 'app/area/favourite/components/url-to-survey-manager';
import { getSctwLink } from 'app/infrastructure/hosting';
import { MenuAccess } from '../../../types';

export const hasDashboardOrReportAdministrationAccess = (menuAccess: MenuAccess) =>
  menuAccess.dashboardAdministration
  || menuAccess.companyReportAdministration
  || menuAccess.favouriteAdministration;

export const canManageSurveys = (menuAccess: MenuAccess, manageSurveysUrl: string) =>
  menuAccess.manageSurveys
  && manageSurveysUrl
  && isValidUrl(urlToSurveyManager(manageSurveysUrl));

export const hasOtherToolsAccess = (menuAccess: MenuAccess) =>
  menuAccess.refreshCache || menuAccess.regenerateAggregatedData;

export const canUseSystemConfigurationTool = (menuAccess: MenuAccess) =>
  menuAccess.systemConfigurationTool && getSctwLink() && isValidUrl(getSctwLink());
